import { Injectable } from '@angular/core';
import { AnalyticsGA4PagesModel } from './analytics-ga4-pages-models';
import { JourneyService } from '../journey/journey.service';
import { TrackTypes } from '../journey/tracks/model/track-types';
import { TrackGA4NativeService } from '../comunicator-native/track-ga4-native/track-ga4-native';
import { ParamDefaultGA4 } from '../comunicator-native/track-ga4-native/itrack-ga4-native';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsGA4PageService {

    constructor(
        private journeyService: JourneyService,
        private trackGA4NativeService: TrackGA4NativeService
    ) {

    }

    public setAnalyticsPageGA4(): AnalyticsGA4PagesModel {

        const journey = this.journeyService.journey;
        const analyticsPageGA4: AnalyticsGA4PagesModel = new AnalyticsGA4PagesModel();

        switch (journey) {
            case TrackTypes.BASIC_V2:
                this.setBasicV2GA4Common(analyticsPageGA4);
                this.setBasicV2GA4Profile(analyticsPageGA4);
                this.setBasicV2GA4Personal(analyticsPageGA4);
                this.setBasicV2GA4Address(analyticsPageGA4);
                this.setBasicV2GA4MaritalStatus(analyticsPageGA4);
                this.setBasicV2GA4Professional(analyticsPageGA4);
                this.setBasicV2GA4Income(analyticsPageGA4);
                this.setBasicV2GA4Minor(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.BASIC_PROFILE_V2:
                this.setBasicV2GA4Common(analyticsPageGA4);
                this.setBasicV2GA4Profile(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.BASIC_PERSONAL_V2:
                this.setBasicV2GA4Common(analyticsPageGA4);
                this.setBasicV2GA4Personal(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.BASIC_ADDRESS_V2:
                this.setBasicV2GA4Common(analyticsPageGA4);
                this.setBasicV2GA4Address(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.BASIC_MARITAL_V2:
                this.setBasicV2GA4Common(analyticsPageGA4);
                this.setBasicV2GA4MaritalStatus(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.BASIC_PROFESSIONAL_V2:
                this.setBasicV2GA4Common(analyticsPageGA4);
                this.setBasicV2GA4Professional(analyticsPageGA4);
                this.setBasicV2GA4Income(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.BASIC_INCOME_V2:
                this.setBasicV2GA4Common(analyticsPageGA4);
                this.setBasicV2GA4Income(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.UPDATE_REGISTRATION:
                this.setUpdateRegistrationGA4Common(analyticsPageGA4);
                this.setUpdateRegistrationGA4Profile(analyticsPageGA4);
                this.setUpdateRegistrationGA4MaritalStatus(analyticsPageGA4);
                this.setUpdateRegistrationGA4Address(analyticsPageGA4);
                this.setUpdateRegistrationGA4Professional(analyticsPageGA4);
                this.setUpdateRegistrationGA4Income(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.UPDATE_PROFILE:
                this.setUpdateRegistrationGA4Common(analyticsPageGA4);
                this.setUpdateRegistrationGA4Profile(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.UPDATE_ADDRESS:
                this.setUpdateRegistrationGA4Common(analyticsPageGA4);
                this.setUpdateRegistrationGA4Address(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.UPDATE_MARITAL:
                this.setUpdateRegistrationGA4Common(analyticsPageGA4);
                this.setUpdateRegistrationGA4MaritalStatus(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.UPDATE_PROFESSIONAL:
                this.setUpdateRegistrationGA4Common(analyticsPageGA4);
                this.setUpdateRegistrationGA4Professional(analyticsPageGA4);
                this.setUpdateRegistrationGA4Income(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.UPDATE_INCOME:
                this.setUpdateRegistrationGA4Common(analyticsPageGA4);
                this.setUpdateRegistrationGA4Income(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.UPDATE_INCOME_CONTA_ION:
                this.setUpdateRegistrationGA4Common(analyticsPageGA4);
                this.setUpdateRegistrationGA4Income(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.CONTA_ION:
                this.setContaIonGA4Common(analyticsPageGA4);
                this.setContaIonGA4Personal(analyticsPageGA4);
                this.setContaIonGA4MaritalStatus(analyticsPageGA4);
                this.setContaIonGA4Address(analyticsPageGA4);
                this.setContaIonGA4Professional(analyticsPageGA4);
                this.setContaIonGA4Income(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.CONTA_ION_PERSONAL:
                this.setContaIonGA4Common(analyticsPageGA4);
                this.setContaIonGA4Personal(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.CONTA_ION_MARITAL:
                this.setContaIonGA4Common(analyticsPageGA4);
                this.setContaIonGA4MaritalStatus(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.CONTA_ION_ADDRESS:
                this.setContaIonGA4Common(analyticsPageGA4);
                this.setContaIonGA4Address(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.CONTA_ION_PROFESSIONAL:
                this.setContaIonGA4Common(analyticsPageGA4);
                this.setContaIonGA4Professional(analyticsPageGA4);
                this.setContaIonGA4Income(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.CONTA_ION_INCOME:
                this.setContaIonGA4Common(analyticsPageGA4);
                this.setContaIonGA4Income(analyticsPageGA4);
                return analyticsPageGA4;
            case TrackTypes.FIRST_ACCESS:
                this.setBasicV2GA4FirstAccess(analyticsPageGA4);
                return analyticsPageGA4;
            default:
                return analyticsPageGA4;
        }
    }

    public sendTrackGA4(paramDefautl: ParamDefaultGA4, paramComplementary?: Record<string, string>) {

        if (Object.values(paramDefautl).every(val => val === '')) {
            return;
        }

        // remove as propriedades com valor string vazia do objeto
        const complementaryFiltered = paramComplementary ? Object.entries(paramComplementary).reduce((a, [k, v]) => (v ? (a[k] = v, a) : a), {}) : undefined;
        return this.trackGA4NativeService.trackGA4(paramDefautl, complementaryFiltered)
    }

    private setUpdateRegistrationGA4Common(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.implementationTeam = 's000846:rtc';
        analyticsPageGA4.customPathAtualizacao = '/atualizacao-cadastral/atualizacao';
        analyticsPageGA4.customPathConfiraSeusDados = '/atualizacao-cadastral/conferir-dados';
        analyticsPageGA4.customPathVinculoCorretora = '/atualizacao-cadastral/vinculo-corretora-itau/selecionar';
        analyticsPageGA4.customPathPessoasVinculadas = '/atualizacao-cadastral/vinculo-corretora-itau/pessoas-vinculadas';
        analyticsPageGA4.customPathTermos = '/atualizacao-cadastral/finalizacao/aceitar-termos';
        analyticsPageGA4.customPathTelaSucesso = '/atualizacao-cadastral/finalizacao/em-analise';
        analyticsPageGA4.customPathCompletarDadosAppItau = '/cadastro-investidor/completar-dados-app-itau';
    }

    private setUpdateRegistrationGA4Profile(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathNomeEscolhido = '/atualizacao-cadastral/dados-contato/nome-escolhido';
        analyticsPageGA4.customPathEmail = '/atualizacao-cadastral/dados-contato/email';
        analyticsPageGA4.customPathCelular = '/atualizacao-cadastral/dados-contato/celular';
    }

    private setUpdateRegistrationGA4MaritalStatus(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathEstadoCivil = '/atualizacao-cadastral/estado-civil/selecionar';
        analyticsPageGA4.customPathConjuge = '/atualizacao-cadastral/estado-civil/conjuge';
    }

    private setUpdateRegistrationGA4Address(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathCep = '/atualizacao-cadastral/endereco/cep';
        analyticsPageGA4.customPathEnderecoCompleto = '/atualizacao-cadastral/endereco/complete';
    }

    private setUpdateRegistrationGA4Professional(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathOrigemRenda = '/atualizacao-cadastral/dados-profissionais/origem-renda';
        analyticsPageGA4.customPathProfissao = '/atualizacao-cadastral/dados-profissionais/profissao';
        analyticsPageGA4.customPathCnpj = '/atualizacao-cadastral/dados-profissionais/info-empresa';
    }

    private setUpdateRegistrationGA4Income(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathRenda = '/atualizacao-cadastral/renda-patrimonio/renda-mensal';
        analyticsPageGA4.customPathPatrimonio = '/atualizacao-cadastral/renda-patrimonio/patrimonio-total';
        analyticsPageGA4.customPathPaisResidenciaFiscal = '/atualizacao-cadastral/renda-patrimonio/res-fiscal-qual-pais';
        analyticsPageGA4.customPathNumeroNif = '/atualizacao-cadastral/renda-patrimonio/numero-nif';
        analyticsPageGA4.customPathDataNif = '/atualizacao-cadastral/renda-patrimonio/inicio-res-fiscal';
    }

    //Conta-ion
    private setContaIonGA4Common(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.implementationTeam = 's001655:rtc';
        analyticsPageGA4.customPathConfiraSeusDados = '/abertura-conta/dados-perfil/checar-dados';
    }

    private setContaIonGA4Personal(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathNomeCompleto = '/abertura-conta/dados-perfil/nome-completo';
        analyticsPageGA4.customPathNumeroDocumento = '/abertura-conta/dados-pessoais/numero-doc';
        analyticsPageGA4.customPathTipoDocumento = '/abertura-conta/dados-pessoais/escolher-doc';
        analyticsPageGA4.customPathOrgaoExpedidor = '/abertura-conta/dados-pessoais/orgao-expedidor';
        analyticsPageGA4.customPathEstadoExpeditor = '/abertura-conta/dados-pessoais/estado-expedicao';
        analyticsPageGA4.customPathNomeMae = '/abertura-conta/dados-pessoais/nome-da-mae';
        analyticsPageGA4.customPathNascionalidade = '/abertura-conta/dados-pessoais/nacionalidade';
        analyticsPageGA4.customPathPaisNascimento = '/abertura-conta/dados-pessoais/pais-nascimento';
        analyticsPageGA4.customPathEstadoNascimento = '/abertura-conta/dados-pessoais/estado-nascimento';
        analyticsPageGA4.customPathCidadeNascimento = '/abertura-conta/dados-pessoais/cidade-nascimento';
        analyticsPageGA4.customPathGenero = '/abertura-conta/dados-pessoais/sexo-nascimento';
    }

    private setContaIonGA4MaritalStatus(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathEstadoCivil = '/abertura-conta/estado-civil/selecionar';
        analyticsPageGA4.customPathConjuge = '/abertura-conta/estado-civil/conjuge';
    }

    private setContaIonGA4Address(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathCep = '/abertura-conta/endereco/cep';
        analyticsPageGA4.customPathEnderecoCompleto = '/abertura-conta/endereco/complete';
    }

    private setContaIonGA4Professional(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPahExpostaPoliticamente = '/abertura-conta/dados-profissionais/exposta-politicamente';
        analyticsPageGA4.customPathOrigemRenda = '/abertura-conta/dados-profissionais/origem-renda';
        analyticsPageGA4.customPathProfissao = '/abertura-conta/dados-profissionais/profissao';
        analyticsPageGA4.customPathCnpj = '/abertura-conta/dados-profissionais/info-empresa';
    }

    private setContaIonGA4Income(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathRenda = '/abertura-conta/renda-patrimonio/renda-mensal';
        analyticsPageGA4.customPathPatrimonio = '/abertura-conta/renda-patrimonio/patrimonio-total';
        analyticsPageGA4.customPathPaisResidenciaFiscalBrasil = '/abertura-conta/renda-patrimonio/residencia-fiscal-br';
        analyticsPageGA4.customPathPaisResidenciaFiscal = '/abertura-conta/renda-patrimonio/res-fiscal-qual-pais';
        analyticsPageGA4.customPathNumeroNif = '/abertura-conta/renda-patrimonio/numero-nif';
        analyticsPageGA4.customPathDataNif = '/abertura-conta/renda-patrimonio/inicio-res-fiscal';
    }

    //Basic V2
    private setBasicV2GA4Common(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.implementationTeam = 's000846:rtc';
        analyticsPageGA4.customPathOverview = '/cadastro-investidor/dados-perfil/conferir';
        analyticsPageGA4.customPathConfiraSeusDados = '/cadastro-investidor/finalizacao/conferir-dados';
        analyticsPageGA4.customPathVinculoCorretora = '/cadastro-investidor/vinculo-corretora-itau/selecionar';
        analyticsPageGA4.customPathPessoasVinculadas = '/cadastro-investidor/vinculo-corretora-itau/pessoas-vinculadas';
        analyticsPageGA4.customPathTermos = '/cadastro-investidor/finalizacao/aceitar-termos';
        analyticsPageGA4.customPathTelaSucesso = '/cadastro-investidor/finalizacao/em-analise';
        analyticsPageGA4.customPathConhecaProdutos = '/cadastro-investidor/conheca-produtos';
        analyticsPageGA4.customPathCompletarDadosAppItau = '/cadastro-investidor/completar-dados-app-itau';
        analyticsPageGA4.customPathOfertaServicos = '/cadastro-investidor/oferta-custodia-e-rlp';
    }
    private setBasicV2GA4Profile(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathNomeEscolhido = '/cadastro-investidor/dados-perfil/nome-escolhido';
        analyticsPageGA4.customPathEmail = '/cadastro-investidor/dados-perfil/email';
        analyticsPageGA4.customPathCelular = '/cadastro-investidor/dados-perfil/celular';
    }
    private setBasicV2GA4Personal(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathTipoDocumento = '/cadastro-investidor/dados-pessoais/escolher-doc';
        analyticsPageGA4.customPathNomeCompleto = '/cadastro-investidor/dados-pessoais/nome-completo';
        analyticsPageGA4.customPathNumeroDocumento = '/cadastro-investidor/dados-pessoais/numero-doc';
        analyticsPageGA4.customPathOrgaoExpedidor = '/cadastro-investidor/dados-pessoais/orgao-expedidor';
        analyticsPageGA4.customPathEstadoExpeditor = '/cadastro-investidor/dados-pessoais/estado-expedicao';
        analyticsPageGA4.customPathNomeMae = '/cadastro-investidor/dados-pessoais/nome-da-mae';
        analyticsPageGA4.customPathDataNascimento = '/cadastro-investidor/dados-pessoais/data-nascimento';
        analyticsPageGA4.customPathPaisNascimento = '/cadastro-investidor/dados-pessoais/pais-nascimento';
        analyticsPageGA4.customPathEstadoNascimento = '/cadastro-investidor/dados-pessoais/estado-nascimento';
        analyticsPageGA4.customPathCidadeNascimento = '/cadastro-investidor/dados-pessoais/cidade-nascimento';
        analyticsPageGA4.customPathNascionalidade = '/cadastro-investidor/dados-pessoais/nacionalidade';
        analyticsPageGA4.customPathGenero = '/cadastro-investidor/dados-pessoais/sexo-nascimento';
    }

    private setBasicV2GA4MaritalStatus(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathEstadoCivil = '/cadastro-investidor/estado-civil/selecionar';
        analyticsPageGA4.customPathConjuge = '/cadastro-investidor/estado-civil/conjuge';
    }

    private setBasicV2GA4Address(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathCep = '/cadastro-investidor/endereco/cep';
        analyticsPageGA4.customPathEnderecoCompleto = '/cadastro-investidor/endereco/complete';
    }

    private setBasicV2GA4Professional(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathOrigemRenda = '/cadastro-investidor/dados-profissionais/origem-renda';
        analyticsPageGA4.customPathProfissao = '/cadastro-investidor/dados-profissionais/profissao';
        analyticsPageGA4.customPathCnpj = '/cadastro-investidor/dados-profissionais/info-empresa';
    }

    private setBasicV2GA4Income(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.customPathRenda = '/cadastro-investidor/renda-patrimonio/renda-mensal';
        analyticsPageGA4.customPathPatrimonio = '/cadastro-investidor/renda-patrimonio/patrimonio-total';
    }

    private setBasicV2GA4FirstAccess(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.implementationTeam = 's000846:rtc';
        analyticsPageGA4.customAceitarTermosUso = '/login/aceitar-termos-de-uso-app';
        analyticsPageGA4.customAceitarTermosUsoTermos = '/login/aceitar-termos-de-uso-app/termos';
    }

    private setBasicV2GA4Minor(analyticsPageGA4: AnalyticsGA4PagesModel) {
        analyticsPageGA4.implementationTeam = 's000846:rtc';
        analyticsPageGA4.customPathMenorDeIdade = '/cadastro-investidor/menores-de-18-anos';
    }
}
